export const getDefaultLanguage = (service_title) => {
  if (service_title && service_title.length) {
    return service_title[0]
  }
  return new Error('service_title[0] not found');
};

export const getOtherLanguages = (service_title) => {
  if (service_title && service_title.length) {
    return service_title.filter((language, index) => index !== 0);
  }
  return [];
};
